// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BM75","name":"styles_name__1XcHj","phone":"styles_phone__3cK8T"};